import React, { createContext, useContext, useMemo, useRef, useState } from "react";

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const timeoutRefs = useRef({});

  function dismissNotification(id) {
    setNotifications((current) =>
      current.filter((notification) => notification.id !== id),
    );

    if (timeoutRefs.current[id]) {
      clearTimeout(timeoutRefs.current[id]);
      delete timeoutRefs.current[id];
    }
  }

  function notify(message, type = "success") {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

    setNotifications((current) => [...current, { id, message, type }]);

    timeoutRefs.current[id] = setTimeout(() => {
      dismissNotification(id);
    }, 3000);
  }

  const value = useMemo(
    () => ({
      notify,
      dismissNotification,
    }),
    [],
  );

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <div
        style={{
          position: "fixed",
          right: "24px",
          bottom: "24px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          zIndex: 9999,
        }}
      >
        {notifications.map((notification) => (
          <div
            key={notification.id}
            style={{
              minWidth: "300px",
              maxWidth: "360px",
              padding: "16px 18px",
              borderRadius: "10px",
              border: "1px solid var(--gray1)",
              backgroundColor: "var(--white)",
              boxShadow: "0 16px 40px rgba(0, 0, 0, 0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px",
            }}
          >
            <span
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor:
                  notification.type === "error"
                    ? "var(--danger)"
                    : "var(--primary)",
                flexShrink: 0,
              }}
            />
            <p
              style={{
                margin: 0,
                flex: 1,
                textAlign: "start",
                color: "var(--gray9)",
                fontSize: "14px",
                lineHeight: "150%",
                fontWeight: 500,
              }}
            >
              {notification.message}
            </p>
            <button
              type="button"
              onClick={() => dismissNotification(notification.id)}
              style={{
                border: "none",
                backgroundColor: "transparent",
                color: "var(--gray5)",
                cursor: "pointer",
                fontSize: "16px",
                lineHeight: 1,
                padding: 0,
              }}
            >
              x
            </button>
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error("useNotification must be used within a NotificationProvider.");
  }

  return context;
}
